import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex h-full min-h-0 flex-col bg-[#F5F6F8] p-4 sm:p-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-1 items-center justify-center rounded-2xl bg-white"
}
const _hoisted_3 = { class: "text-sm text-[#626468]" }
const _hoisted_4 = {
  key: 1,
  class: "flex min-h-0 flex-1 flex-col gap-5"
}
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = { class: "w-full sm:w-80 lg:w-64" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "flex items-center gap-3 sm:ml-2 sm:space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["AuraProcessingCostsHeader"], {
      "is-loading": $setup.isLoading,
      onRefresh: $setup.loadCosts
    }, null, 8 /* PROPS */, ["is-loading"]),
    (!$setup.canView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('aura.processingCosts.accessDenied')), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode($setup["UiDatePicker"], {
                modelValue: $setup.dateRange,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateRange) = $event)),
                range: "",
                multiCalendars: "",
                "min-date": $setup.activatedMinDate
              }, null, 8 /* PROPS */, ["modelValue", "min-date"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["UiPanel"], {
              class: "flex flex-col gap-3 px-4 py-2 sm:flex-row sm:items-center",
              "no-padding": ""
            }, {
              default: _withCtx(() => [
                _createVNode($setup["UiListSearch"], {
                  modelValue: $setup.search,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.search) = $event)),
                  placeholder: _ctx.$t('aura.processingCosts.filters.search')
                }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode($setup["AuraProcessingCostsSort"], {
                    modelValue: $setup.sortMenuSelected,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.sortMenuSelected) = $event))
                  }, null, 8 /* PROPS */, ["modelValue"]),
                  _createVNode($setup["AuraProcessingCostsFiltersPanel"], {
                    modelValue: $setup.filters,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters) = $event)),
                    users: $setup.users
                  }, null, 8 /* PROPS */, ["modelValue", "users"])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            ($setup.sortMenuSelected.length || $setup.activeFilters.length)
              ? (_openBlock(), _createBlock($setup["UiPanel"], {
                  key: 0,
                  class: "space-x-2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortMenuSelected, (selected) => {
                      return (_openBlock(), _createBlock($setup["UiSortMenuBadge"], {
                        key: selected.key,
                        item: selected,
                        onRemove: ($event: any) => ($setup.removeSort(selected))
                      }, null, 8 /* PROPS */, ["item", "onRemove"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeFilters, (filter) => {
                      return (_openBlock(), _createBlock($setup["UiBadge"], {
                        key: filter.field,
                        removable: "",
                        onRemove: ($event: any) => ($setup.removeFilter(filter.field))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(filter.label) + ": " + _toDisplayString(filter.value), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onRemove"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode($setup["AuraProcessingCostsSummary"], {
            "total-cost": $setup.formatCost($setup.totalCost),
            "total-items": $setup.total,
            "total-tokens": $setup.totalTokens.toLocaleString('pt-BR')
          }, null, 8 /* PROPS */, ["total-cost", "total-items", "total-tokens"]),
          _createVNode($setup["AuraProcessingCostsTable"], {
            items: $setup.items,
            "is-loading": $setup.isLoading,
            "format-cost": $setup.formatCost,
            "format-date": $setup.formatDate
          }, null, 8 /* PROPS */, ["items", "is-loading"]),
          ($setup.items.length)
            ? (_openBlock(), _createBlock(_component_UiPagination, {
                key: 0,
                modelValue: $setup.filters.page,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.page) = $event)),
                count: $setup.total,
                "per-page": $setup.filters.perPage || 25
              }, null, 8 /* PROPS */, ["modelValue", "count", "per-page"]))
            : _createCommentVNode("v-if", true)
        ]))
  ]))
}